import { InjectionToken } from '@angular/core';

/**
 * @description
 * Provide max image size and max document size in MB
 *
 */
export const AttachmentSizeLimitsToken = new InjectionToken<{
  imgMaxSize: number;
  docMaxSize: number;
}>('Attachment limits configuration');
